import { Fragment } from "react";
import { makeSorteo } from "../../api/sorteo";
import { Form, Input, message, Button } from "antd";
import { useAuth } from "../../utils/useAuth";
import { useHistory } from "react-router-dom";

function DeleteRecord({ closeModal }) {
  const { user } = useAuth();
  const history = useHistory();

  const onFinish = (values) => {
    sendDataToServer(values);
  };

  const sendDataToServer = async (data) => {
    data.dnisorteador = user.documentNumber;

    try {
      const response = await makeSorteo(data);
      const { codigosorteo } = response.payload;
      history.push("/app/sortear?codigo=" + codigosorteo);
      message.success(response.message);
      closeModal();
      console.log(response);
    } catch (err) {
      message.error(err.message);
    }
  };

  // ----- render -----
  return (
    <Fragment>
      <Form onFinish={onFinish} layout="vertical">
        <Form.Item
          label="Número de ganadores"
          name="nroganadores"
          rules={[
            {
              required: true,
              message: "El Número de ganadores es necesario"
            }
          ]}
        >
          <Input type="number" className="text-xl" />
        </Form.Item>

        <div className="w-full flex gap-4 justify-end">
          <Button type="primary" htmlType="submit">
            Sortear
          </Button>

          <Button type="default" onClick={() => closeModal()}>
            Cancelar
          </Button>
        </div>
      </Form>
    </Fragment>
  );
}
export default DeleteRecord;
